export default "__VITE_ASSET__BheRSSP9__"